const dayjs = require('dayjs');
const formatDate = (number, item) => {
  return dayjs().add(number, item).subtract(1, 'day').utc().startOf('day').format().replace('Z', '');
};

export { formatDate };
